<template>
  <Modal v-model="showModal" draggable :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">更改合同状态</span>
    </p>
    <div style="position: relative;" :style="'height:' + height + 'px'">
      <Spin v-if="loadingStatus" fix />
      <Form ref="contractStatusForm" :label-width="110" :rules="ruleValidate">
        <FormItem label="当前状态:" prop="currentStatus">
          <span style="font-size: 9pt;">{{ currentStatus | code2label(contractStatusList) }}</span>
        </FormItem>
        <FormItem label="目标状态:" prop="targetStatus">
          <Select
            v-model="targetStatus"
            :label-in-value="true"
            size="small"
            clearable
            filterable
          >
            <Option
              v-for="(option, index) in contractStatusList"
              :key="index"
              :value="option.code"
              :label="option.label"
              :disabled="currentStatus === option.code || currentStatus > option.code"
            />
          </Select>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        更改状态
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'ContractStatus',
  filters: {
    code2label(code, stat) {
      const matched = stat.find(s => s.code === code)
      return matched ? matched.label : '待处理'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 250
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    currentStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      targetStatus: 0
    }
  },
  computed: {
    ruleValidate() {
      return {
      }
    },
    contractStatusList() {
      return [
        // { code: 0, label: '待处理', hidden: true },
        { code: 1, label: '进行中' },
        { code: 2, label: '已完成' },
        { code: 3, label: '已拒绝' }

      ]
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  methods: {
    saveOrUpdate() {
      const _this = this
      if (this.id && this.targetStatus) {
        request({
          url: this.action + '/' + this.id + '/action/changeStatus?status=' + _this.targetStatus,
          method: 'put'
        }).then(res => {
          _this.loadingStatus = false
          _this.$Notice.success({ title: '合同状态更改成功' })
          _this.submit = false
          _this.closeModal(true)
        }).catch(() => {
          _this.loadingStatus = false
          _this.submit = false
          _this.$Notice.error({ title: '合同状态更改失败' })
        })
      } else {
        _this.$Notice.error({ title: '请选择目标合同状态...' })
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
